import { getAttribute } from "../../../../../../utils/utils/get-line-item-attribute.js";
import { getLineItemImageUrl } from "../../../../../../utils/utils/get-line-item-image-url.js";
import { getLocalizedAttribute } from "../../../../../../utils/utils/get-line-item-localized-attribute.js";
import { getLineItemPrice } from "../../../../../../utils/utils/get-line-item-price.js";
import { getProductUrl } from "../../../../../../utils/utils/get-line-item-product-url.js";
import { getLocalizedString } from "../../../../../../utils/utils/get-localized-string.js";
import { getSharedProps } from "../../../../../../utils/utils/shared-line-item-data-mapper.js";
import { getBundledLineItemProductVariant } from "../../../utils/bundles/mappers/view/line-item/utils/bundles/get-bundled-line-item-product-variant.js";
import { getBundledProductInfo } from "../../../utils/prescription-glasses/mappers/view/line-item/utils/prescription-glasses/get-bundled-product-info.js";
const mapNonPrescriptionBundleLineItem = (lineItemRaw, settings, intl) => {
  const { locale } = intl;
  const mainBundleLineItem = lineItemRaw.bundleLineItems.find(
    (bundleLineItem) => bundleLineItem.isMainBundleLineItem
  );
  if (!mainBundleLineItem) {
    console.error(
      `None of the bundleLineItems have isMainBundleLineItem in LineItemBundle with id ${lineItemRaw.id}`
    );
    return null;
  }
  const configurationBundleItem = lineItemRaw.bundleLineItems.find(
    (item) => item.legacyProduct.productType === "configurationbundle"
  );
  if (!configurationBundleItem) {
    console.error(
      `None of the bundleLineItems is a configurationbundle in LineItemBundle with id ${lineItemRaw.id}`
    );
    return null;
  }
  const shared = getSharedProps(lineItemRaw, mainBundleLineItem.legacyProduct, intl);
  const variant = getBundledLineItemProductVariant(mainBundleLineItem);
  const slug = getLocalizedString(locale, mainBundleLineItem.legacyProduct.masterData.current.slug);
  const offering = getBundledProductInfo(configurationBundleItem, intl);
  const mainBundleItemPrice = mainBundleLineItem.price ? getLineItemPrice(mainBundleLineItem.price, intl.locale).unit : void 0;
  return {
    ...shared,
    type: "non-prescription-bundle",
    imageUrl: getLineItemImageUrl(variant),
    name: getLocalizedString(locale, mainBundleLineItem.legacyProduct.masterData.current.name),
    productUrl: getProductUrl(settings.productLinkFormatter, lineItemRaw, slug, locale),
    productId: lineItemRaw.id,
    sku: lineItemRaw.sku,
    mainBundleItemPrice,
    offering,
    brand: {
      name: getAttribute(variant, "brand"),
      model: getAttribute(variant, "brandModel"),
      modelCode: getAttribute(variant, "brandModelCode"),
      modelColorCode: getAttribute(variant, "brandModelColorCode")
    },
    erpId: getAttribute(variant, "erpId"),
    frame: {
      frameType: getLocalizedAttribute(variant, "frameType", "en"),
      faceShape: getLocalizedAttribute(variant, "faceShape", "en")
    }
  };
};
export {
  mapNonPrescriptionBundleLineItem
};
//# sourceMappingURL=non-prescription-bundle.js.map
